export const translationUploadData_sv_part1 = {
  expirationPicker: "Datum och tid",
  errorFetchingIndexes: "Fel vid hämtning av index. Försök igen.",
  errorFetchingData: "Fel vid hämtning av data. Försök igen.",
  errorConversations: "Fel vid hämtning av konversationer. Försök igen.",
  tokenChatbotMissing: "Token eller chatbotID hittades inte",
  convoResolved: "Konversation markerad som löst.",
  errorUpdatingConvo: "Fel vid uppdatering av konversation.",
  titleRequired: "Titel krävs.",
  titleLimit: "Titeln får inte överstiga 50 tecken.",
  tokenNotFound: "Token hittades inte.",
  errorUpdatingData: "Fel vid uppdatering av data.",
  dataUpdated: "Data uppdaterad i",
  dataAdded: "Data tillagd i",
  errorUpdating: "Fel vid uppdatering av data i",
  errorAdding: "Fel vid tillägg av data till",
  dataDeletedFrom: "Data borttagen från",
  errorDeletingFrom: "Fel vid borttagning av data från",
  dataUploaded: "Data uppladdad till",
  errorUploadingTo: "Fel vid uppladdning till",
  convoMarkedResolved: ". Konversation markerad som löst.",
  myInfoChunks: "Mina informationsdelar",
  lackingInfoConvos: "Konversationer med saknad information",
  conversationDetails: "Konversationsdetaljer",
  uploadDataHeader: "Ladda upp och hantera information",
  addNew: "Lägg till ny",
  addNewInfo: "Lägg till ny info",
  noConversationSelected: "Ingen konversation vald.",
  deleteLabel: "Ta bort",
  conversationID: "Konversations-ID",
  dateLabel: "Datum",
  topicLabel: "Ämne",
  uncategorized: "Okategoriserat",
  requiredTitlePlaceholder: "Ange en titel för din information",
  uploadInfoPlaceholder: "Ange den information du vill ladda upp",
  uploadFormattingToolbar: "Textformatering",
  uploadFormattingBold: "Fetstil",
  uploadFormattingItalic: "Kursiv",
  uploadFormattingHint: "Använd knapparna för fetstil eller kursiv text.",
  chunkOverridesSection: "Chatbot-anpassningar",
  chunkOverridesHint:
    "Markera en del av texten och klicka på Lägg till anpassning — välj sedan vilka chatbotar som ska ha sin egen version av den delen. Anpassade delar markeras: håll muspekaren för att se, klicka för att redigera. Anpassningar gäller bara chatbotar som använder den här kunskapsbasen.",
  overridesAdd: "Lägg till anpassning",
  overridesEditorIntro: "Välj de chatbotar som ska säga något annat här.",
  overridesRemove: "Ta bort",
  overridesEmptyHint: "Inga anpassningar — alla chatbotar använder den delade texten.",
  overridesTextPlaceholder: "Version av innehållet för den här chatboten",
  overridesSelectionMissing: "Markera först den del av texten du vill anpassa.",
  overridesOriginalLabel: "Original",
  overridesOverrideLabel: "Ersättning för den här chatboten",
  overridesStaleWarning:
    "Den ursprungliga texten finns inte längre i den delade versionen — den här anpassningen är inaktiv.",
  overridesEntireTextLabel: "Hela texten ersätts för den här chatboten",
  overridesPreviewLabel: "Visa texten som den här chatboten kommer att använda",
  overridesDone: "Klar",
  overridesSearchChatbots: "Sök chatbotar",
  overridesNoChatbotMatches: "Inga chatbotar matchar den sökningen.",
  overridesAddAllChatbots: "Lägg till alla",
  overridesCountHint: "Chatbotar med sin egen version av den här delen / chatbotar som kan ha en",
  chatbot: "Chatbot",
  fileUploadChooseFile: "Välj fil",
  updating: "Uppdaterar...",
  uploading: "Laddar upp...",
  update: "Uppdatera",
  upload: "Ladda upp",
  cancel: "Avbryt",
  removing: "Tar bort...",
  remove: "Ta bort",
  addNotesHere: "Lägg till anteckningar här...",
  dataDeletedMessage: "Data borttagen från",
  errorDeletingMessage: "Fel vid borttagning av data från",
  deleteFromAll: "Ta bort från alla kunskapsbaser",
  confirmDeleteAll: "Är du säker på att du vill ta bort från alla kunskapsbaser?",
  deletedFromAll: "Borttagen från alla kunskapsbaser",
  expiresAt: "Upphör",
  sortByLabel: "Sortera efter:",
  sortByDateNewest: "Datum (nyaste först)",
  sortByTitleAZ: "Titel (A–Ö)",
  companyInfo: "Företagsinformation",
  livechat: "Livechat",
  typeYourAnswer: "Skriv ditt svar här...",
  previous: "Föregående",
  next: "Nästa",
  agentNameLabel: "Ditt agentnamn",
  agentNamePlaceholder: "Ange ditt agentnamn",
  saveAgentName: "Spara agentnamn",
  agentNameSaved: "Agentnamn sparat!",
  searchConversationsPlaceholder: "Sök konversationer, ID:n eller användar-ID:n...",
  pageLabel: "Sida",
  userIDLabel: "Användar-ID",
  freshdeskFormVisualOnly: "Det här är bara en visuell representation av kontaktformuläret",
  addNotesPlaceholder: "Lägg till anteckningar här...",
  freshdeskContactSupport: "Kontakta kundservice",
  freshdeskYourEmail: "Din e-post:",
  freshdeskEmailPlaceholder: "exempel@mail.se",
  freshdeskSupportMessage: "Meddelande till kundservice:",
  freshdeskMessagePlaceholder: "Skriv ditt meddelande här...",
  freshdeskUploadImageOptional: "Ladda upp bild (valfritt):",
  freshdeskChooseFile: "Välj fil",
  freshdeskNoFileChosen: "Ingen fil vald",
  freshdeskSendInquiry: "Skicka förfrågan",
  leadgenContactForm: "Kontaktformulär",
  leadgenNameLabel: "Ditt namn",
  leadgenNamePlaceholder: "Ange ditt namn",
  leadgenEmailLabel: "Din e-post",
  leadgenEmailPlaceholder: "Ange din e-post",
  leadgenSubmitButton: "Skicka",
  leadgenFormVisualOnly: "Det här formuläret visas enbart i dashboarden",
  searchInfoChunks: "Sök i dina informationsdelar...",
  selectOption: "Välj alternativ",
  selectKnowledgebase: "Välj kunskapsbas",
  selectKnowledgebaseTooltip:
    "Välj vilken kunskapsbas innehållet ska lagras i – till exempel produkter för produktinfo och allmänt för allmän information. Om du är osäker, lägg till båda.",
  deadlineOptional: "Deadline (valfritt)",
  optional: "Valfritt",
  expirationDate: "Utgångsdatum",
  scheduleUpload: "Schemalägg uppladdning",
  scheduleTime: "Schemalagd tid",
  selectScheduleTime: "Välj tid för uppladdning",
  scheduleDateTime: "Datum och tid",
  immediateUpload: "Ladda upp nu",
  scheduledUpload: "Schemalagd uppladdning",
  scheduleRequired: "Schemalagd tid krävs",
  scheduleTimeInPast: "Schemalagd tid måste vara i framtiden",
};
